import React from 'react';
import { ACTIVE_BRAND } from '../branding';
import './ProcessingPage.css';

function ProcessingPage() {
  return (
    <div className="processing-page">
      <div className="processing-content">
        <div className="processing-card">
          <div className="spinner"></div>
          <h2 className="processing-title" style={{ color: ACTIVE_BRAND.colors.primary }}>
            PROCESSING YOUR DOCUMENT
          </h2>
          <p className="processing-text">
            Please wait while we verify your identity...
          </p>
          <div className="processing-steps">
            <div className="step">
              <span className="step-icon">✓</span>
              <span className="step-text">Document scanned</span>
            </div>
            <div className="step">
              <span className="step-icon">✓</span>
              <span className="step-text">Selfie captured</span>
            </div>
            <div className="step active">
              <span className="step-icon">⏳</span>
              <span className="step-text">Analyzing data</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessingPage;
